"use client";

import type { AssistantDiscoveryUiState } from "./discovery-state";
import { initialDiscoveryState } from "./discovery-state";

const STORAGE_NAMESPACE = "merc-assistant-discovery";

function getStorageKey(namespaceId: string) {
  return `${STORAGE_NAMESPACE}::${namespaceId}`;
}

export function loadDiscoveryState(namespaceId: string): AssistantDiscoveryUiState {
  if (typeof window === "undefined") {
    return initialDiscoveryState;
  }

  const key = getStorageKey(namespaceId);
  const raw = window.localStorage.getItem(key);
  if (!raw) {
    return initialDiscoveryState;
  }

  try {
    const parsed = JSON.parse(raw) as AssistantDiscoveryUiState;
    return {
      showGlow: parsed.showGlow ?? initialDiscoveryState.showGlow,
      showTooltip: parsed.showTooltip ?? initialDiscoveryState.showTooltip,
      showOverlay: parsed.showOverlay ?? initialDiscoveryState.showOverlay,
      glowFirstSeenAt: parsed.glowFirstSeenAt ?? initialDiscoveryState.glowFirstSeenAt,
      sessionsSinceHint: parsed.sessionsSinceHint ?? initialDiscoveryState.sessionsSinceHint,
    };
  } catch (error) {
    console.warn("Unable to parse assistant discovery state", error);
    return initialDiscoveryState;
  }
}

export function persistDiscoveryState(namespaceId: string, state: AssistantDiscoveryUiState) {
  if (typeof window === "undefined") {
    return;
  }

  const key = getStorageKey(namespaceId);
  window.localStorage.setItem(key, JSON.stringify(state));
}
